import Api from "../../lib/request";
import cookie from "../../lib/cookie";
import COOKIECONSTANT from "../../constant/cookie";
import qs from "querystring";
import { checkStateNew, checkHttps } from "@src/api/";

const url = COOKIECONSTANT.REQUEST_HOST
export const newsList = data => {
  return new Promise((resolve, reject) => {
    Api.get(`${url}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.common.district-control.home-page-control-list",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        resolve(checkStateNew(data) || false)
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};

export const newsListApp = data => {
  return new Promise((resolve, reject) => {
    Api.get(`${url}?${qs.stringify(data)}`, {
      headers: {
        "Content-Type": "application/json",
        "X-Host": "mall.msg.msg-list",
        "X-Token": cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ""
      }
    })
      .then(data => {
        resolve(checkStateNew(data) || false)
      })
      .catch(e => {
        checkHttps(e, reject(e));
      });
  });
};